import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { Button } from "primereact/button";

import { translationKeys } from "../../../models/app-translation-keys";
import { GlobalErrorMessages } from "../../Shared/GlobalErrorMessages/GlobalErrorMessages";

import "./GlobalErrorsPage.scss";

const RawGlobalErrorsPage: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="global-errors-page">
      <GlobalErrorMessages />

      <Link to="/">
        <Button label={t(translationKeys.navigation.backToLandingPage)} />
      </Link>
    </div>
  );
};

export const GlobalErrorsPage = observer(RawGlobalErrorsPage);
